<template>
  <div class="layout" :class="designThemeClass">
    <div v-if="isDesignPreview" class="design-version-badge">
      <span>{{ isV2 ? 'V2' : 'V1' }}</span>
      <div>
        <strong>{{ isV2 ? '明亮赛事版' : '品牌融合版' }}</strong>
        <small>{{ isV2 ? 'LIGHT EVENT EDITION' : 'BRAND SYSTEM EDITION' }}</small>
      </div>
      <button @click="switchDesign">{{ isV2 ? '查看 V1' : '查看 V2' }}</button>
    </div>
    <NavPC
      v-if="!useCompactNav"
      id="nav"
      class="nav-pc"
      :bookLink="bookLink"
      :navData="$t('home.nav')"
      @changeNav="changeNav"
      @setLang="setLangConfig"
    />
    <NavMobile
      id="nav"
      class="nav-mobile"
      :navData="$t('home.nav')"
      :logo="logo"
      :bookLink="bookLink"
      @changeNav="changeNav"
      @setLang="setLangConfig"
      v-else
    />
    <slot name="banner">
      <Banner v-if="useBanner" />
    </slot>

    <slot />

    <div class="toast" v-if="showToast && isMobile">{{ isEnLang ? 'Coming soon' : '敬请期待' }}</div>
  </div>
</template>

<script>
import NavPC from './nav'
import NavMobile from './navMobile'
import Banner from './banner'

import { mapState, mapActions } from 'vuex'

import qs from 'query-string'

export default {
  name: 'layout',
  components: {
    NavPC,
    NavMobile,
    Banner
  },
  props: {
    useBanner: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showToast: false,
      viewportWidth: typeof window === 'undefined' ? 1440 : window.innerWidth,
      logo: require('@/assets/transSave/resource/image/d9/6e/d9fdf5e8ea899511244yy656c9f6ca6e.png')
    }
  },
  computed: {
    ...mapState(['isMobile', 'isEnLang']),

    // The full desktop navigation needs more horizontal space than a number of
    // common laptop viewports provide. Keep the page layout independent from
    // this breakpoint and use the compact navigation before items can overflow.
    useCompactNav () {
      return this.isMobile || this.viewportWidth <= 1180
    },

    isV2 () {
      return this.$route.query.design === 'v2'
    },
    isDesignPreview () {
      return ['v1', 'v2'].includes(this.$route.query.design)
    },
    designThemeClass () {
      return this.isV2 ? 'theme-v2-deep-navy' : 'theme-v1-color-roadmap'
    },

    bookLink () {
      const link = 'https://www.infoq.cn/form/'
      const parsed = { ...qs.parse(location.search), id: 2789 }
      return `${link}?${qs.stringify(parsed)}`

      // return 'https://www.infoq.cn/form/?id=2789&utm_source=gw&sign=iq_68beb62d0aa70'
    }
  },
  created () {
    // console.log(this.$t('nav'))
  },
  mounted () {
    window.addEventListener('resize', this.updateViewportWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateViewportWidth)
  },
  methods: {
    ...mapActions([
      'setLang'
    ]),

    switchDesign () {
      this.$router.replace({
        query: { ...this.$route.query, design: this.isV2 ? 'v1' : 'v2' },
        hash: this.$route.hash
      })
    },

    updateViewportWidth () {
      this.viewportWidth = window.innerWidth
    },

    setLangConfig (val) {
      const currentPath = this.$route.path
      const currentPrimaryName = this.$route.meta.primaryName || this.$route.name.replace(/En$/, '')
      const targetName = val === 'en-US' ? `${currentPrimaryName}En` : currentPrimaryName
      const targetRoute = this.$router.resolve({ name: targetName, query: this.$route.query, hash: this.$route.hash })

      this.setLang(val).then(() => {
        if (targetRoute.route.path !== currentPath) {
          this.$router.push({ name: targetName, query: this.$route.query, hash: this.$route.hash })
        }
      })
    },

    getHash (path) {
      let hash = ''

      if (`${path}`.indexOf('#') > -1) {
        hash = `#${path.split('#')[1]}`
      }

      return hash
    },

    changeNav (item) {
      const hash = this.getHash(item.hash)

      // if (item.name.slice(0, 5) === 'https') return window.open(item.name)

      const routeName = this.isEnLang && item.name && !item.name.endsWith('En') ? `${item.name}En` : item.name

      if (routeName !== this.$route.name) {
        console.log('changNav', item)
        this.$router.push({ name: routeName })
          .then(() => {
            if (hash) this.scrollToAnchor(hash)
          })
          .catch((err) => {
            console.log('changNav err', err)
            if (hash) this.scrollToAnchor(hash)
          })
      } else {
        if (hash) this.scrollToAnchor(hash)
      }
    },

    scrollToAnchor (hash) {
      if (!hash) return
      const nav = document.querySelector('#nav')
      if (!nav) return
      const offset = -nav.offsetHeight
      if (document.querySelector(hash)) {
        this.$scrollTo(hash, 500, { offset })
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$scrollTo(hash, 500, { offset })
          }, 800)
        })
      }

      this.$router.replace({ hash })
    }
  }
}
</script>

<style lang="scss" scoped>

.layout {
  position: relative;
  overflow: hidden;
  width: 100%;
  // width: 1500px;
  // background: #13101a;

  @include enlayoutInner {
    text-align: left !important;
  }
}

.nav-pc {
  position: fixed; left: 0; right: 0;
  z-index: 200;
  border-bottom: 1px solid #D8D8D8;
  background: rgba(255,255,255,.94);
  backdrop-filter: blur(12px);
}

.nav-mobile {
  // background: #13101A;
}

.toast {
  position: fixed; top: 200px; left: 50%; z-index: 1001;
  width: 100px;
  margin-left: -50px; padding: 0 20px;
  background: #13101a;
  border: 1px solid #13101a;
  border-radius: 30px;
  font-size: 14px;
  // color: #FFF;
}

@include mobile {
  .layout {
    @include enlayoutInner {
      text-align: left !important;
    }
  }
}
</style>
